import axios from 'axios';

const CRM_WEB_URL = process.env.REACT_APP_CRM_WEB_URL || 'https://crm.cahwindow.co.kr';

// 중복 리다이렉트 방지 플래그
let isRedirectingToLogin = false;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 에러 시 CRM 로그인 페이지로 리다이렉트
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 중복 리다이렉트 방지
      if (isRedirectingToLogin) {
        console.log('⚠️ 이미 로그인 페이지로 리다이렉트 중 - 중복 실행 방지');
        return Promise.reject(error);
      }

      isRedirectingToLogin = true;

      // 1. 로컬 스토리지 데이터 삭제
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      localStorage.removeItem('features');

      // 2. 사용자에게 알림
      alert('로그인 세션이 만료되었습니다.\n로그인 페이지로 이동합니다.');

      // 3. 도메인 체크 및 리다이렉트
      const currentHostname = window.location.hostname;
      const currentPort = window.location.port;

      // CRM 도메인 체크 - 환경변수 기반
      const crmUrl = new URL(CRM_WEB_URL);
      const isCRMDomain = currentHostname === crmUrl.hostname &&
                          (!crmUrl.port || currentPort === crmUrl.port);

      if (isCRMDomain) {
        // CRM 내부 → 깔끔하게 /login으로
        console.log('🔒 세션 만료 - CRM 내부에서 로그인 페이지로 이동');
        window.location.href = '/login';
      } else {
        // 외부 도메인(견적계산기 등) → returnUrl 포함
        const currentUrl = window.location.href;
        const returnUrl = encodeURIComponent(currentUrl);
        const loginUrl = `${CRM_WEB_URL}/login?returnUrl=${returnUrl}`;

        console.log('🔒 세션 만료 - CRM 로그인 페이지로 리다이렉트');
        console.log('현재 URL:', currentUrl);
        console.log('returnUrl:', returnUrl);
        console.log('이동할 URL:', loginUrl);

        window.location.href = loginUrl;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
